/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/role_permission_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./role_permission_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.RolePermissionServiceClient =
  function RolePermissionServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.RolePermissionServicePromiseClient =
  function RolePermissionServicePromiseClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListRolesRequest,
 *   !proto.stronachgroup.first.racehorse360.ListRolesResponse>}
 */
const methodDescriptor_RolePermissionService_ListRoles =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.RolePermissionService/ListRoles",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListRolesRequest,
    stronachgroup_first_racehorse360_messages_pb.ListRolesResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListRolesRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListRolesResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListRolesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListRolesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListRolesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.RolePermissionServiceClient.prototype.listRoles =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RolePermissionService/ListRoles",
      request,
      metadata || {},
      methodDescriptor_RolePermissionService_ListRoles,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListRolesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListRolesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.RolePermissionServicePromiseClient.prototype.listRoles =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RolePermissionService/ListRoles",
      request,
      metadata || {},
      methodDescriptor_RolePermissionService_ListRoles
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListRolePermissionsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListRolePermissionsResponse>}
 */
const methodDescriptor_RolePermissionService_ListRolePermissions =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.RolePermissionService/ListRolePermissions",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListRolePermissionsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListRolePermissionsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListRolePermissionsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListRolePermissionsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListRolePermissionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListRolePermissionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListRolePermissionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.RolePermissionServiceClient.prototype.listRolePermissions =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RolePermissionService/ListRolePermissions",
      request,
      metadata || {},
      methodDescriptor_RolePermissionService_ListRolePermissions,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListRolePermissionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListRolePermissionsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.RolePermissionServicePromiseClient.prototype.listRolePermissions =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RolePermissionService/ListRolePermissions",
      request,
      metadata || {},
      methodDescriptor_RolePermissionService_ListRolePermissions
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
